/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AssetReportDtoListBaseResponse } from '../models/asset-report-dto-list-base-response';
import { AssetStatsDtoBaseResponse } from '../models/asset-stats-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class DashService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiDashAssetStatsGet
   */
  static readonly ApiDashAssetStatsGetPath = '/api/Dash/asset-stats';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashAssetStatsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetStatsGet$Plain$Response(params?: {
    breakdownStart?: string;
    breakdownEnd?: string;
    profitStart?: string;
    profitEnd?: string;
    dispatchStart?: string;
    dispatchEnd?: string;
  }): Observable<StrictHttpResponse<AssetStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashService.ApiDashAssetStatsGetPath, 'get');
    if (params) {
      rb.query('breakdownStart', params.breakdownStart, {});
      rb.query('breakdownEnd', params.breakdownEnd, {});
      rb.query('profitStart', params.profitStart, {});
      rb.query('profitEnd', params.profitEnd, {});
      rb.query('dispatchStart', params.dispatchStart, {});
      rb.query('dispatchEnd', params.dispatchEnd, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssetStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashAssetStatsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetStatsGet$Plain(params?: {
    breakdownStart?: string;
    breakdownEnd?: string;
    profitStart?: string;
    profitEnd?: string;
    dispatchStart?: string;
    dispatchEnd?: string;
  }): Observable<AssetStatsDtoBaseResponse> {

    return this.apiDashAssetStatsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AssetStatsDtoBaseResponse>) => r.body as AssetStatsDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashAssetStatsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetStatsGet$Json$Response(params?: {
    breakdownStart?: string;
    breakdownEnd?: string;
    profitStart?: string;
    profitEnd?: string;
    dispatchStart?: string;
    dispatchEnd?: string;
  }): Observable<StrictHttpResponse<AssetStatsDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashService.ApiDashAssetStatsGetPath, 'get');
    if (params) {
      rb.query('breakdownStart', params.breakdownStart, {});
      rb.query('breakdownEnd', params.breakdownEnd, {});
      rb.query('profitStart', params.profitStart, {});
      rb.query('profitEnd', params.profitEnd, {});
      rb.query('dispatchStart', params.dispatchStart, {});
      rb.query('dispatchEnd', params.dispatchEnd, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssetStatsDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashAssetStatsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetStatsGet$Json(params?: {
    breakdownStart?: string;
    breakdownEnd?: string;
    profitStart?: string;
    profitEnd?: string;
    dispatchStart?: string;
    dispatchEnd?: string;
  }): Observable<AssetStatsDtoBaseResponse> {

    return this.apiDashAssetStatsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AssetStatsDtoBaseResponse>) => r.body as AssetStatsDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiDashAssetBreakdownReportGet
   */
  static readonly ApiDashAssetBreakdownReportGetPath = '/api/Dash/asset-breakdown-report';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashAssetBreakdownReportGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetBreakdownReportGet$Plain$Response(params?: {
    startDate?: string;
    endDate?: string;
  }): Observable<StrictHttpResponse<AssetReportDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashService.ApiDashAssetBreakdownReportGetPath, 'get');
    if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('endDate', params.endDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssetReportDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashAssetBreakdownReportGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetBreakdownReportGet$Plain(params?: {
    startDate?: string;
    endDate?: string;
  }): Observable<AssetReportDtoListBaseResponse> {

    return this.apiDashAssetBreakdownReportGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<AssetReportDtoListBaseResponse>) => r.body as AssetReportDtoListBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiDashAssetBreakdownReportGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetBreakdownReportGet$Json$Response(params?: {
    startDate?: string;
    endDate?: string;
  }): Observable<StrictHttpResponse<AssetReportDtoListBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DashService.ApiDashAssetBreakdownReportGetPath, 'get');
    if (params) {
      rb.query('startDate', params.startDate, {});
      rb.query('endDate', params.endDate, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AssetReportDtoListBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiDashAssetBreakdownReportGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiDashAssetBreakdownReportGet$Json(params?: {
    startDate?: string;
    endDate?: string;
  }): Observable<AssetReportDtoListBaseResponse> {

    return this.apiDashAssetBreakdownReportGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<AssetReportDtoListBaseResponse>) => r.body as AssetReportDtoListBaseResponse)
    );
  }

}
